import { makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../../../actions';
import { XmlAssetAPI } from '../../../../../API/xmlAsset';
import DefaultScrollWithHeaderContent from '../../../../utils/DefaultScrollWithHeaderContent';
import MyTable from '../../../../utils/MyTable';
import { useState } from 'react';


const useStyles = makeStyles({
    root: {
        display: 'flex',

        '& .defaultScrollWithHeaderContent': {
            width: "100%",

        }
    },
});

export default function XmlAssetsTab(props) {

    const { selectedYear } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const rightContent = useSelector(state => state.rightContent)

    const [listAssets, setListAssets] = React.useState([]);

    const [innerLoad, setInnerLoad] = useState({ emptyMessage: "", loadMessage: "Carregando informações...", size: "small" });

    const loadAssets = async () => {
        const response = await XmlAssetAPI.getAll();

        console.log("response assets: ", response);
        if (response.success) {

            if (response.body.rows.length === 0) {
                setInnerLoad({ emptyMessage: "Nenhum ativo XML cadastrado." });
            } else {
                setListAssets(response.body.rows.map(el => ({
                    ...el,
                    clients: el.clients_with_audesp_cod !== "" ? JSON.parse(el.clients_with_audesp_cod) : []
                })));
                setInnerLoad(null);
            }

        } else {
            setInnerLoad({ emptyMessage: "Erro ao carregar ativos XML." });
        }
    }

    useEffect(() => {

        if (!clientOn?.client?.id) return;
        loadAssets(clientOn.client.id);

    }, [clientOn?.client?.id]);

    useEffect(() => {
        if (rightContent && rightContent.action) {
            dispatch(allActions.rightContentActions.setRightContent(null))
            loadAssets(clientOn.client.id);
        }
    }, [rightContent])


    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>

                <MyTable
                    selectable="true"
                    stickyHeader
                    size="small">
                    <colgroup>
                        <col width="25%" />
                        <col width="30%" />

                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Nome</TableCell>
                            <TableCell align="left">CNPJ</TableCell>
                            <TableCell className="ellipsis" align="left">Clientes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listAssets.map((row) => (

                            <TableRow key={"xml-asset-sp-" + row.id} onClick={
                                () => dispatch(allActions.rightContentActions.setRightContent({
                                    path: 'newXmlAsset',
                                    update: true,
                                    data: { ...row }
                                }))
                            }>
                                <TableCell className="ellipsis" align="left">{row.name}</TableCell>
                                <TableCell align="left">{row.cnpj}</TableCell>
                                <TableCell className="ellipsis" align="left">{row.clients.map(el => el.client.label_name).join(', ')}</TableCell>
                                {/* <TableCell align="left">{row.cnpj}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </MyTable>
            </DefaultScrollWithHeaderContent>

        </div>
    );
}